import { createFileRoute, useParams } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { SettingsPageHeader } from '@/components/ui';
import { BusinessSetupPageShell } from './business-setup/components/business-setup-page-shell';
import { NavigationLayoutPreferenceCard } from './appearance/components/navigation-layout-preference-card';
import { formatDocumentTitle } from '@/lib/document-title';

export const Route = createFileRoute('/_auth/$orgId/settings/appearance')({
  component: AppearancePage,
});

function AppearancePage() {
  const { orgId } = useParams({ from: '/_auth/$orgId/settings/appearance' });

  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Appearance')}</title>
      </Helmet>

      <BusinessSetupPageShell orgId={orgId} activePath="appearance">
        <SettingsPageHeader
          title="Appearance"
          description="Choose how primary app navigation appears across your workspace."
        />

        <div className="max-w-2xl">
          <NavigationLayoutPreferenceCard />
        </div>
      </BusinessSetupPageShell>
    </>
  );
}
